import PropTypes from 'prop-types';
import React, { Component } from 'react';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import Button from 'yoda-core-components/lib/components/Button';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Input from 'yoda-core-components/lib/components/Input/Input';
import copyToClipBoard from '../../common/copyToClipBoard';

class MyShareListLink extends Component {
    static propTypes = {
        isPublic: PropTypes.bool.isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        /* eslint react/no-unused-prop-types: 0 */
        shareToken: PropTypes.string,
        accountId: PropTypes.string.isRequired,
        shareListTracking: PropTypes.string.isRequired,
        location: PropTypes.objectOf,
    };

    static defaultProps = {
        shareToken: null,
        location: {
            pathname: '',
            query: {
                id: '',
            },
        },
    };

    constructor() {
        super();
        this.state = {
            isLinkCopied: false,
        };
        this.copyToClipBoard = this.copyToClipBoard.bind(this);
        this.getMessageBox = this.getMessageBox.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    getMessageBox(type, message) {
        // eslint-disable-next-line no-param-reassign
        message = (
            <p className={dt(['text-success-border', 'text-medium', 'font-semibold'])}>{message}</p>
        );
        return (
            <div
                className={dt(['w-full', 'flex', 'justify-center', 'mb-10'])}
                data-automation-id="share-link-copy-message"
            >
                <MessageBox
                    contentClassName={dt(['!ml-8'])}
                    hasClose={false}
                    type={type}
                    title={message}
                    level="inline"
                />
            </div>
        );
    }

    copyToClipBoard() {
        if (copyToClipBoard('share-list-url')) {
            this.setState({
                isLinkCopied: true,
            });
        } else {
            this.setState({
                isLinkNotCopied: false,
            });
        }
    }

    render() {
        const { messagesTexts, accountId, shareToken, location } = this.props;
        const {
            successMessage,
            errorMessage,
            newHeader,
            shareListTracking,
            description,
            buttons: { copyToClipBoardButton },
        } = messagesTexts;
        const { isLinkCopied, isLinkNotCopied } = this.state;

        const shareUrl = `${window.location.origin + location.pathname}`;
        const query = makeQuery(location.search) || {};
        const {
            id: qId = 'myFavorites',
            accountId: qAccountId,
            token: qToken,
            cid: qCid,
            trending: qTrending,
        } = query;

        let shareListUrl =
            shareToken &&
            `${shareUrl}?id=${qId}&accountId=${accountId}&token=${shareToken}&cid=${shareListTracking}`;
        if (qId && qAccountId && qToken && (qCid || qTrending)) {
            shareListUrl = `${shareUrl}?id=${qId}&accountId=${qAccountId}&token=${qToken}&cid=${shareListTracking}`;
        }
        return (
            <div className={dt(['grid'])}>
                <h2
                    className={dt(['text-black', 'leading-8', 'text-xLg', 'mb-2', 'mt-6'])}
                    data-automation-id="share-link-heading"
                >
                    {newHeader}
                </h2>
                <p className={dt(['text-medium', 'text-black'])}>{description}</p>
                <div className={dt(['mt-6', isLinkCopied || isLinkNotCopied ? 'mb-6' : 'mb-10'])}>
                    <Input
                        data-automation-id="share-link-url"
                        type="text"
                        name="shareListLink"
                        value={shareListUrl}
                        theme={dt([
                            'h-12',
                            'w-[79%]',
                            'border',
                            'border-solid',
                            'border-gray-60',
                            'py-3',
                            'px-5',
                            'text-small',
                            'text-black',
                            'float-left',
                            'rounded-r-none',
                            'rounded-l-lg',
                            'smMd:w-[75%]',
                            'border-r-white',
                        ])}
                        id="share-list-url"
                    />
                    <Button
                        automationId="share-link-url-copy"
                        size="Lg"
                        className={dt([
                            'rounded-l-none',
                            'float-left',
                            'w-[21%]',
                            'smMd:w-[25%]',
                            '!text-base',
                            '!leading-6',
                        ])}
                        onClick={this.copyToClipBoard}
                        data-automation-id="copyToClipBoardButton"
                    >
                        {copyToClipBoardButton}
                    </Button>
                </div>
                {(isLinkCopied || isLinkNotCopied) && (
                    <div>
                        {isLinkNotCopied
                            ? this.getMessageBox('error', errorMessage)
                            : this.getMessageBox('success', successMessage)}
                    </div>
                )}
            </div>
        );
    }
}

export default MyShareListLink;
